import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { PropTypes } from 'prop-types'
import { useTranslation } from 'react-i18next'
import UIButton from '../components/UI/UIButton'
import { COLOR_BLACK, COLOR_WHITE } from '../lib/colors'
import { leToBr } from '../utils/Utils'
import ReportReason from './ReportReason'
import { toast } from 'react-toastify'

const ReportMakerPopup = ({ closeToast, onEndLive }) => {
  const { t } = useTranslation('translation')

  const handleContinue = () => {
    closeToast()
    toast(<ReportReason endLive={onEndLive} />, {
      autoClose: false,
      closeOnClick: false,
      draggable: true,
      closeButton: false,
      className: 'toast-container',
      toastClassName: 'toast',
    })
  }

  return (
    <div className={css(styles.containerPopup)}>
      <p className={css(styles.title)}>
        {leToBr(t('pages.live.reportMakerTitle'))}
      </p>
      <p className={css(styles.message)}>
        {leToBr(t('pages.live.reportMakerMessage'))}
      </p>
      <p className={css(styles.question)}>
        {leToBr(t('pages.live.doYouWantToReport'))}
      </p>
      <div className={css(styles.containerButtonPopup)}>
        <UIButton
          design="invertedPrimary"
          label={t('common.button.no')}
          onClick={closeToast}
        />
        <UIButton
          design="primary"
          label={t('common.button.yes')}
          onClick={handleContinue}
        />
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  containerPopup: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 700,
    fontSize: '1.2em',
    textAlign: 'center',
    color: COLOR_BLACK,
    backgroundColor: COLOR_WHITE,
    padding: '1.5em',
  },
  containerButtonPopup: {
    display: 'flex',
    alignItems: 'center',
    gap: '2em',
    fontWeight: 700,
    color: COLOR_WHITE,
    marginTop: '0.5em',
  },
  message: {
    fontSize: '0.8em',
    fontWeight: 400,
    margin: 0,
  },
  question: {
    fontSize: '0.8em',
  },
})

ReportMakerPopup.propTypes = {
  closeToast: PropTypes.func,
  onEndLive: PropTypes.func,
}

export default ReportMakerPopup
